<template>
  <div>
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" key="english">
        <h1 id="welcome" class="lastname">Welcome</h1>
        <div class="welcomeModal">
          <h2>Here's my portfolio.</h2>
          <p>
            All the work I did since I started are shown here, you can navigate
            by using desktop icons on the left, but also with taskbar icons.
          </p>
          <div class="wiki">
            <span class="topBar">
              <span class="padding">
                <div class="largerBtn">❒</div>
                <div class="closeBtn">✕</div>
              </span>
            </span>
            <span class="wikiText">: interact with the window</span>
          </div>
          <div class="wiki">
            <div class="langSelect">
              <span @click="english = false" class="lang fr">FR</span>
              <span @click="english = true" class="lang en">EN</span>
            </div>
            <span class="wikiText"> : switch the language</span>
          </div>
          Primary color and background can also be changed in the settings,
          located in the start menu
          <Settings />
        </div>
      </div>
      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" key="french">
        <h1 id="welcome" class="lastname">Bienvenue</h1>
        <div class="welcomeModal">
          <h2>Voici mon portfolio.</h2>
          <p>
            Toute mes créations depuis que j'ai débuté sont présentes ici, vous
            pouvez naviguer en cliquant sur les icônes de bureau ou de la barre
            des tâches.
          </p>
          <div class="wiki">
            <span class="topBar">
              <span class="padding">
                <div class="largerBtn">❒</div>
                <div class="closeBtn">✕</div>
              </span>
            </span>
            <span class="wikiText">: interagit avec la fenêtre</span>
          </div>
          <div class="wiki">
            <div class="langSelect">
              <span @click="english = false" class="lang fr">FR</span>
              <span @click="english = true" class="lang en">EN</span>
            </div>
            <span class="wikiText"> : change la langue</span>
          </div>
          La couleur principale et le fond d'écran peuvent également être
          changés dans les paramètres, situé dans le menu Démarrer
          <Settings />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Settings from "../infoComponents/Settings";

export default {
  components: {
    Settings,
  },
  props: {
    english: Boolean,
  },
};
</script>

<style>
h1#welcome {
  font-size: 3.7rem !important;
  margin-bottom: 0.5rem;
  margin-top: -5px !important;
}
h3 {
  font-weight: lighter;
}
.welcomeModal {
  text-align: center;
}
.welcomeModal .topBar,
.welcomeModal .langSelect {
  width: 40% !important;
  float: right;
  position: unset;
}
.welcomeModal .padding {
  padding: none;
  margin: 0 auto;
}
.welcomeModal .settings {
  justify-content: center;
  margin-top: 10px;
}
.wiki {
  display: flex;
  margin-bottom: 10px;
}
.wikiText {
  margin: 0 5px;
}
</style>